import { SailsTariffOverviewStorage } from 'Container/App/interface';
import { getFlowTypeFromSails } from '@vfde-sails/storage';
import {
    FLOW_SUBSCRIPTIONS_FIRST,
    FlowType,
} from '@vfde-sails/constants';

/**
 * Get getTradeIn from storage or orl
 */
export const getFlowType = (storage: SailsTariffOverviewStorage | null): FlowType => {
    if (!storage) {
        return FLOW_SUBSCRIPTIONS_FIRST;
    }

    return getFlowTypeFromSails(storage) || FLOW_SUBSCRIPTIONS_FIRST;
};
